export const whatIsWifiEdges = [
  {
    id: "205.243.255.95-242.47.214.213",
    source: "242.47.214.213",
    target: "205.243.255.95",
    type: "straight",
  },
];
